import React, { FC, ChangeEvent } from 'react'
import { makeStyles } from 'tss-react/mui'
import { Theme } from '@mui/material/styles'
import { CircularProgress, CircularProgressProps } from '@mui/material'

const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    color: theme.palette.primary.main,
    display: 'flex',
    alignSelf: 'center',
  },
}))

interface MuiCustomSpinner extends CircularProgressProps {
  changeHandler?(event: ChangeEvent): void
}

const LoadingSpinner: FC<MuiCustomSpinner> = ({ ...props }) => {
  const { classes } = useStyles()

  return <CircularProgress classes={{ root: classes.root }} {...props} />
}

export default LoadingSpinner
